module.exports = __webpack_public_path__ + "img/BentonHarborStateBank_1913postcard.540817e8.jpg";